import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const StyledTitle = styled.div`
  display: block;
  background-color: ${colors.white};
  font-size: 10px;
  line-height: 15px;

  @media ${device.smallScreen} {
    display: none;
  }
`
